import { render, staticRenderFns } from "./McBasicForm.vue?vue&type=template&id=9f233650&scoped=true&"
import script from "./McBasicForm.vue?vue&type=script&lang=js&"
export * from "./McBasicForm.vue?vue&type=script&lang=js&"
import style0 from "./McBasicForm.vue?vue&type=style&index=0&id=9f233650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f233650",
  null
  
)

export default component.exports